@if (!loading && !error) {
  <div class="details-wrap">
    <!-- Header -->
    <section class="header card">
      <div class="left">
        <h3>Order #{{ details?.publicOrderCode }}</h3>
        <div class="sub">
          <span class="chip">{{ details?.orderStatus | titlecase }}</span>
          <span class="dot" aria-hidden="true">•</span>
          <span class="chip alt">{{
            details?.orderType || "-" | titlecase
          }}</span>
        </div>
      </div>
      <div class="right total">
        {{
        details?.orderTotalCurrentGross || 0
        | currency: "GBP" : "symbol" : "1.2-2"
        }}
      </div>
    </section>
    @if (hasOrderComment) {
      <section class="section card note-block">
        <h4 class="section-title">
          Customer note
          <button
            type="button"
            class="linkish copy-btn"
            (click)="copy(orderComment)"
            >
            Copy
          </button>
        </h4>
        <p class="note-text">{{ orderComment }}</p>
      </section>
    }
    <!-- (Optional) Internal note -->
    @if (hasTenantComment) {
      <section class="section card note-block internal">
        <h4 class="section-title">
          Internal note
          <button
            type="button"
            class="linkish copy-btn"
            (click)="copy(tenantComment)"
            >
            Copy
          </button>
        </h4>
        <p class="note-text">{{ tenantComment }}</p>
      </section>
    }
    <!-- Customer / Delivery -->
    @if (details?.phoneNumber || details?.orderType === 'delivery') {
      <section
        class="section card customer-details"
        >
        <h4 class="section-title">Customer Details</h4>
        <div
          class="customer-details-grid"
          [class.has-address]="details?.orderType === 'delivery'"
          >
          @if (details?.phoneNumber) {
            <div class="customer-info-box phone-box">
              <span class="field-label">Phone number</span>
              <span class="phone-value">+{{ details?.phoneNumber }}</span>
            </div>
          }
          @if (details?.orderType === 'delivery') {
            <div
              class="customer-info-box address-box"
              >
              <span class="field-label">Delivery address</span>
              <address class="addr">
                {{ details?.delivery?.address_line_1
                }}@if (details?.delivery?.address_line_2) {
                <br />
              }
              @if (details?.delivery?.address_line_2) {
                <span>
                  {{ details?.delivery?.address_line_2 }}<br />
                </span>
              }
              {{ details?.delivery?.city }}, {{ details?.delivery?.county }}<br />
              {{ details?.delivery?.country }} {{ details?.delivery?.postal_code }}
            </address>
          </div>
        }
      </div>
    </section>
  }
  <!-- Items -->
  <section class="section card">
    <h4 class="section-title">
      Items -
      @if (totalItemsCount > 0) {
        <span class="count-pill">{{
          totalItemsCount
        }}</span>
      }
    </h4>
    @if ((details?.details?.length || 0) > 0) {
      <ul class="items">
        @for (it of details?.details || []; track it) {
          <li class="item-card">
            @if (it.categoryName) {
              <div class="item-category">
                {{ it.categoryName }}
              </div>
            }
            <div class="row">
              <div class="name">
                <span class="qty">{{ it.itemQuantity }} ×</span>
                <span>{{ it.itemName }}</span>
              </div>
              <div class="price">
                {{
                it.itemTotalGrossOriginal | currency: "GBP" : "symbol" : "1.2-2"
                }}
              </div>
            </div>
            <!-- removed per request: individual item status + updated time -->
            @if ((it.extras?.length || 0) > 0) {
              <div class="extras">
                <div class="extras-title">Extras</div>
                <ul>
                  @for (ex of it.extras; track ex) {
                    <li>
                      {{ ex.extraQuantity }} × {{ ex.extraName }}
                      @if (ex.extraPrice) {
                        <span class="ex-price">
                          ({{ ex.extraPrice | currency: "GBP" : "symbol" : "1.2-2" }})
                        </span>
                      }
                    </li>
                  }
                </ul>
              </div>
            }
            @if (it.itemNote) {
              <div class="note">
                <span class="note-label">Note:</span> {{ it.itemNote }}
              </div>
            }
          </li>
        }
      </ul>
    } @else {
      <div class="empty">No items found for this order.</div>
    }
  </section>
  <!-- Footer CTAs (sticky) -->
  <section class="footer-ctas">
    <div class="cta-left">
      @if (showAcceptDecline) {
        <button
          class="btn btn-decline-action"
          (click)="decline()"
          [disabled]="actionBusy"
          >
          Decline
        </button>
      }
      @if (canRefund) {
        <button
          class="btn btn-refund-action"
          (click)="onRefund()"
          [disabled]="actionBusy"
          title="Issue a full or partial refund"
          >
          Refund
        </button>
      }
    </div>
    <div class="cta-right">
      <button
        type="button"
        class="btn btn-print-action"
        (click)="printReceipt()"
        [disabled]="!details"
        >
        Print Receipt
      </button>
      @if (showAcceptDecline) {
        <button
          class="btn btn-accept-action"
          (click)="acceptAndPrint()"
          [disabled]="actionBusy"
          >
          Accept
        </button>
      }
      @if (showStartPrep) {
        <button
          class="btn btn-start-prep-action"
          (click)="startPrep()"
          [disabled]="actionBusy"
          >
          Start Prep
        </button>
      }
      @if (showSendDelivery) {
        <button
          class="btn"
        [ngClass]="
          (details?.orderType || 'delivery') === 'collection'
            ? 'btn-ready-collection-action'
            : 'btn-send-delivery-action'
        "
          (click)="sendToDelivery()"
          [disabled]="actionBusy"
          >
          {{
          (details?.orderType || "delivery") === "collection"
          ? "Ready for Collection"
          : "Send to Delivery"
          }}
        </button>
      }
      @if (showComplete) {
        <button
          class="btn btn-complete-action"
          (click)="complete()"
          [disabled]="actionBusy"
          >
          Complete
        </button>
      }
    </div>
  </section>
</div>
} @else {
  @if (loading) {
    <div class="loading">
      <div class="sk-line w60"></div>
      <div class="sk-line w80"></div>
      <div class="sk-line w40"></div>
    </div>
  }
  @if (!loading && error) {
    <div class="error">{{ error }}</div>
  }
}

